// iter87.257 — Official NFL team brand color pairs, keyed by full team
// name as stored on `scheduled_matches.home_label` / `.away_label`
// (e.g. "Buffalo Bills"). Used to render two-tone diagonal-split circle
// swatches in place of vendor team logos (see NflLiveTicker.jsx —
// licensing risk means no crest images anywhere in the app).
export const NFL_TEAM_COLORS = {
    // AFC East
    "Buffalo Bills": ["#00338D", "#C60C30"],
    "Miami Dolphins": ["#008E97", "#F58220"],
    "New England Patriots": ["#002244", "#C60C30"],
    "New York Jets": ["#125740", "#FFFFFF"],
    // AFC North
    "Baltimore Ravens": ["#241773", "#000000"],
    "Cincinnati Bengals": ["#FB4F14", "#000000"],
    "Cleveland Browns": ["#311D00", "#FF3C00"],
    "Pittsburgh Steelers": ["#000000", "#FFB612"],
    // AFC South
    "Houston Texans": ["#03202F", "#A6192E"],
    "Indianapolis Colts": ["#003A70", "#FFFFFF"],
    "Jacksonville Jaguars": ["#006778", "#000000"],
    "Tennessee Titans": ["#0C2340", "#4B92DB"],
    // AFC West
    "Denver Broncos": ["#FB4F14", "#002244"],
    "Kansas City Chiefs": ["#E31837", "#FFB81C"],
    "Las Vegas Raiders": ["#000000", "#A5ACAF"],
    "Los Angeles Chargers": ["#0080C6", "#FFC20E"],
    // NFC East
    "Dallas Cowboys": ["#041E42", "#869397"],
    "New York Giants": ["#0B2265", "#A71930"],
    "Philadelphia Eagles": ["#004C54", "#000000"],
    "Washington Commanders": ["#5A1414", "#FFB612"],
    // NFC North
    "Chicago Bears": ["#0B162A", "#C83803"],
    "Detroit Lions": ["#0076B6", "#B0B7BC"],
    "Green Bay Packers": ["#203731", "#FFB612"],
    "Minnesota Vikings": ["#4F2683", "#FFC62F"],
    // NFC South
    "Atlanta Falcons": ["#A71930", "#000000"],
    "Carolina Panthers": ["#0085CA", "#000000"],
    "New Orleans Saints": ["#000000", "#D3BC8D"],
    "Tampa Bay Buccaneers": ["#D50A0A", "#3E3A39"],
    // NFC West
    "Arizona Cardinals": ["#97233F", "#FFFFFF"],
    "Los Angeles Rams": ["#003594", "#FFA300"],
    "San Francisco 49ers": ["#AA0000", "#B3995D"],
    "Seattle Seahawks": ["#002244", "#69BE28"],
};

function hashColor(name) {
    let hash = 0;
    for (let i = 0; i < (name || "").length; i++) {
        hash = (hash * 31 + name.charCodeAt(i)) % 360;
    }
    return `hsl(${hash}, 55%, 38%)`;
}

// Returns [primary, secondary] — real brand pair when known, otherwise
// a deterministic single-hue fallback (both slots same color) so
// unmapped/legacy names still render a solid swatch.
export function nflTeamColorPair(name) {
    return NFL_TEAM_COLORS[name] || [hashColor(name), hashColor(name)];
}
